import { cn } from "@omni/utils/styles";

import { StorePickerFilters } from "./components/filters/storePickerFilters.container";
import { StorePickerFooterComponent } from "./components/footer/storePickerFooter.component";
import { StorePickerInput } from "./components/input/storePickerInput.container";
import { StorePickerStores } from "./components/stores/storePickerStores.container";

const StorePickerComponent = () => {
    return (
        <section className={cn("tw:h-full tw:flex tw:flex-col tw:gap-4")}>
            <div
                className={cn(
                    "tw:p-4 tw:rounded-md tw:bg-grey tw:flex tw:flex-col tw:items-start"
                )}
            >
                <StorePickerInput className={cn("tw:w-full tw:text-left")} />
                <StorePickerFilters className={cn("tw:w-full tw:text-left")} />
            </div>
            <StorePickerStores />
            <StorePickerFooterComponent />
        </section>
    );
};

export { StorePickerComponent };
